import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, DestroyRef, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { HeaderUserProfileComponent, UserService } from '@pinnakl/outlook-addin';
import { Toast } from 'primeng/toast';
import { filter } from 'rxjs/operators';

@Component({
  imports: [RouterModule, Toast, NgOptimizedImage, HeaderUserProfileComponent],
  selector: 'app-root',
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'tw:block tw:h-full' },
})
export class AppComponent {
  private readonly router = inject(Router);
  private readonly userService = inject(UserService);
  private readonly destroyRef = inject(DestroyRef);
  protected readonly showProfileMenu = signal(this.computeShowProfileMenu(this.router.url));

  constructor() {
    this.router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe(event => this.showProfileMenu.set(this.computeShowProfileMenu(event.urlAfterRedirects)));
  }

  private computeShowProfileMenu(url: string): boolean {
    return !url.startsWith('/login') && !!this.userService.getUser();
  }
}
